import React, { useContext, useEffect, useState } from 'react';
import { ServiceResponse } from '../../../app/services/shared/interfaces';
import { AppContext } from '../../../contexts/AppContext';
import useReactConfirmAlert from '../../../hooks/useReactConfirmAlert';
import FundsRequestDataTable from '../../WorkOrders/components/tables/FundsRequestDataTable';
import { FundRequestStatus, FundsFilters, FundsRequestDataForm } from '../../../app/models/Fund';
import useFundsRequestService from '../../../app/services/hooks/useFundsRequestService';
import { toast } from 'react-toastify';
import { Society } from '../../../app/models/Society';

interface Props {
    onSaved?: () => void;
    onCancel?: () => void;
    onError?: () => void;
}

const DownloadFundRequestsTxt = ({
    onSaved,
    onCancel,
    onError
}: Props) => {

    const { getAllFundsRequests, 
        fetchingAllFundsRequest, 
        deleteFundsRequest,
        getTxtAllFundsRequests
    } = useFundsRequestService();


    const { showLoading, hideLoading, changeAnimation, showProgressiveLoading } = useContext(AppContext);


    const [ fundsRequests, setFundsRequests] = useState<FundsRequestDataForm[]>([]);    
    const [totalRows, setTotalRows] = useState<number>(0);
    const [ fundRequestStatuses, setFundRequestStatuses ] = useState<FundRequestStatus[]>([])
    const [societies, setSocieties] = useState<Society[]>([]);
    const [filter, setFilter] = useState<FundsFilters>({
        page: 1,
        per_page: 10,
        sort: 'id',
        order: 'desc',
        status: 'REQUEST',
        society: 'PEGASUS LOGISTICS LIMITADA'
    });


    const reloadTable = () => { 
        getAllFundsRequests(filter, {
            onSuccess: (response: ServiceResponse) => {
                setFundsRequests(response.data.funds_requests);
                setTotalRows(response.data.total_rows);
                setFundRequestStatuses(response.data.statuses);
                setSocieties(response.data.societies);
            },
            onError: (response: ServiceResponse) => {
                toast.error(response.message, {
                    autoClose: 2000
                });
            }
        });
    };





    const downloadTxt = () => {
        getTxtAllFundsRequests(filter);
    };

    return (
        <>
            { fundsRequests.length > 0 &&
                <div className="col-12">
                    <div className="row mt-3 align-items-center">
                        <div className="col-auto">
                            <button className="btn btn-success btn-sm" onClick={downloadTxt}>
                                <i className="fa fa-file-excel" /> Descargar .txt
                            </button>
                        </div>
                    </div>
                </div>
            }

            <FundsRequestDataTable 
                fundsRequests={fundsRequests} 
                totalRows={totalRows} 
                statuses={fundRequestStatuses}
                societies={societies}
                filter={filter} 
                setFilter={setFilter}
                loading={fetchingAllFundsRequest}
                callbackSuccess={reloadTable}
                onSearch={reloadTable}
                reloadTable={reloadTable}
                downloadTxt={true}
            />
        </>
        
    );
};

export default DownloadFundRequestsTxt;
